import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const services = [
  {
    title: 'Tour Booking',
    copy: 'National tour booking across entertainment, comedy, and live venues, keeping our artists on stage where they belong.',
  },
  {
    title: 'Show Production',
    copy: 'Hands-on support from concept through curtain call. We build the infrastructure that lets the performance be the only thing on an artist’s mind.',
  },
  {
    title: 'Digital Media',
    copy: 'Social media marketing built around each artist’s voice, growing reach without trading identity for impressions.',
  },
  {
    title: 'Brand Strategy',
    copy: 'Brand partnerships and strategic collaborations that extend reach and create lasting cultural impact.',
  },
];

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="about-section">
      <div className="about-container">
        {/* ---------- Header ---------- */}
        <header className="about-header">
          <span className="about-eyebrow">
            Our Story
          </span>
          <h1 className="about-title">
            We help artists build <em>legacies</em>.
          </h1>
          <p className="about-subtitle">
            LRM Management Inc. is a talent management and production company
            dedicated to helping artists grow every aspect of their career.
          </p>
        </header>

        {/* ---------- Intro paragraph ---------- */}
        <div className="about-intro">
          <p className="about-intro-copy">
            From national tour booking and show production to social media
            marketing and brand partnerships, we provide hands-on support
            across entertainment, comedy, and digital media.
          </p>
        </div>

        {/* ---------- Services ---------- */}
        <div className="about-services">
          <span className="about-section-label">
            What We Do
          </span>

          <div className="about-services-grid">
            {services.map((service, i) => (
              <article className="about-service" key={service.title}>
                <span className="about-service-index" aria-hidden="true">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="about-service-title">{service.title}</h3>
                <p className="about-service-copy">{service.copy}</p>
              </article>
            ))}
          </div>
        </div>

        {/* ---------- Legacy statement ---------- */}
        <div className="about-legacy">
          <div className="about-legacy-rule" aria-hidden="true" />
          <p className="about-legacy-copy">
            We also help our clients achieve personal success by equipping them
            with the tools to grow, manage, and protect their assets,
            building not just <em>careers</em>, but <em>legacies</em>.
          </p>
          <div className="about-legacy-rule" aria-hidden="true" />
        </div>

        {/* ---------- CTA ---------- */}
        <div className="about-cta">
          <p className="about-cta-copy">Ready to build what lasts?</p>
          <div className="about-cta-actions">
            <Link to="/Partnerships" className="about-cta-btn">
              <span className="about-cta-label">Brand Partnerships</span>
              <span className="about-cta-arrow" aria-hidden="true">→</span>
            </Link>
            <Link to="/contact" className="about-cta-btn about-cta-btn--ghost">
              <span className="about-cta-label">Get in Touch</span>
              <span className="about-cta-arrow" aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
